import { getRequiredFields } from 'utils/form'

const fields = [
  {
    label: 'Preferred Name',
    name: 'preferredName',
    layout: 'fullWidth',
    disabled: true,
    type: 'hidden',
  },
  {
    label: 'Date of Birth',
    name: 'DOB',
    layout: 'fullWidth',
    disabled: true,
    type: 'hidden',
  },
  {
    label: 'Place of birth',
    name: 'POB',
    layout: 'fullWidth',
    disabled: true,
    type: 'hidden',
  },
  {
    label: 'Gender',
    name: 'gender',
    layout: 'fullWidth',
    disabled: true,
    type: 'hidden',
  },
  {
    label: 'TFN',
    name: 'TFN',
    layout: 'fullWidth',
    disabled: true,
    type: 'hidden',
  },
  {
    label: 'Primary cost centre Code',
    name: 'primaryCostCentreCode',
    layout: 'fullWidth',
    disabled: true,
    type: 'hidden',
  },
  {
    label: 'Cost centre effective date',
    name: 'costCentreEffectiveDate',
    layout: 'fullWidth',
    disabled: true,
    type: 'hidden',
  },
  {
    label: 'Status',
    name: 'status',
    layout: 'fullWidth',
  },
  {
    label: 'PeopleSoft Company',
    name: 'peopleSoftCompany',
    layout: 'fullWidth',
    disabled: true,
    type: 'hidden',
  },
  {
    label: 'Job Code',
    name: 'jobCode',
    layout: 'fullWidth',
    disabled: true,
    type: 'hidden',
  },
  {
    label: 'EPIC draw down start date',
    name: 'drawDownStartDate',
    layout: 'fullWidth',
  },

  {
    label: 'EPIC draw down end date',
    name: 'drawDownEndDate',
    layout: 'fullWidth',
  },
  {
    label: 'Board Member',
    name: 'boardMember',
    layout: 'fullWidth',
  },
  {
    label: 'Other Name',
    name: 'otherName',
    layout: 'fullWidth',
  },
  {
    label: 'Email',
    name: 'Email',
    layout: 'fullWidth',
    disabled: true,
    type: 'hidden',
  },
  {
    label: 'Business title',
    name: 'businessTitle',
    layout: 'fullWidth',
    disabled: true,
    type: 'hidden',
  },
  {
    label: 'Seconded to',
    name: 'secondedTo',
    layout: 'fullWidth',
  },
  {
    label: 'Date of Admission',
    name: 'dateOfAdmission',
    layout: 'fullWidth',
    disabled: true,
    type: 'hidden',
  },
  {
    label: 'Date of retirement',
    name: 'dateOfRetirement',
    layout: 'fullWidth',
    disabled: true,
    type: 'hidden',
  },
  {
    label: 'Antecedent date',
    name: 'antecedentDate',
    layout: 'fullWidth',
    disabled: true,
    type: 'hidden',
  },
  {
    label: 'Antecendent name',
    name: 'antecendentName',
    layout: 'fullWidth',
    disabled: true,
    type: 'hidden',
  },
  {
    label: 'Pension accrual date',
    name: 'pensionAccrualDate',
    layout: 'fullWidth',
  },
  {
    label: 'Pension commencement date',
    name: 'pensionCommencementDate',
    layout: 'fullWidth',
    disabled: true,
    type: 'hidden',
  },
  {
    label: 'Pension end date',
    name: 'pensionEndDate',
    layout: 'fullWidth',
    disabled: true,
    type: 'hidden',
  },
  {
    label: 'Secondee',
    name: 'secondee',
    layout: 'fullWidth',
  },
  {
    label: 'Spouse full legal name',
    name: 'spouseFullLegalName',
    layout: 'fullWidth',
  },
  {
    label: 'Spouse date of birth (DD/MM/YYYY)',
    name: 'spouseDateOfBirth',
    layout: 'fullWidth',
    validators: [
      {
        check: 'dateFormatDMY',
        error: 'Please enter a valid date in the format DD/MM/YYYY',
      },
    ],
  },
  {
    label: 'Director Id',
    name: 'directorId',
    layout: 'fullWidth',
  },
  {
    label: 'Allocated partner tax manager',
    name: 'allocatedPartnerTaxManager',
    layout: 'fullWidth',
  },      


]

export const requiredFields = getRequiredFields(fields)
export const formFields = fields
export default formFields



// WEBPACK FOOTER //
// ./src/schemas/forms/EditPersonalInfo.js